// MUI
import { ButtonBase, Typography, Stack } from "@mui/material";

// Components
import { AppointmentsStatusDisplay } from "./AppointmentsStatusDisplay";
import { UserMenu } from "./UserMenu";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Auth
import { useMBSAuth } from "Auth/MBS/MBSAuthContext";

// Styles
import { styles } from "./styles";
import { styles as textStyles } from "Common/Styles/TextStyles";

// Libraries
import { useTranslation } from "react-i18next";

// Constants
import { STATUS_PAGES } from "Constants/AppointmentStatusDisplayConstants";

const NavBar = ({ modePreference, onModePreferenceChange }) => {
  const { t } = useTranslation();
  const { user } = useMBSAuth();
  const navigate = useNavigate();

  const firstName = user?.firstName || "";
  const lastName = user?.lastName || "";
  const username = `${firstName} ${lastName}`.trim() || "Anonymous User";

  const normalizedPathname = useLocation().pathname.replace(/\/+$/, "");
  const showStatus = STATUS_PAGES.some((pageName) =>
    normalizedPathname.endsWith("mbs/" + pageName)
  );

  return (
    <Stack direction="row" sx={styles.navBar}>
      <ButtonBase onClick={() => navigate("/mbs/home")}>
        <Typography variant="h1" sx={textStyles.poppinsTitle}>
          {t("mbsNavBar.title")}
        </Typography>
      </ButtonBase>
      <Stack spacing={1} direction="row" width="auto" alignItems="center">
        {showStatus && <AppointmentsStatusDisplay />}
        <UserMenu
          username={username}
          modePreference={modePreference}
          onModePreferenceChange={onModePreferenceChange}
        />
      </Stack>
    </Stack>
  );
};

export default NavBar;
